export default __webpack_public_path__ + "static/media/62.d1917c03.gif";